/**********************************************************************************************
CalculatorHome.tsx - Home page of the kcl gloves calculator application & managing redirections
***********************************************************************************************/
import React from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route } from "react-router-dom";
import ChemicalSearch from "./pages/chemicalSearch/ChemicalSearch";
import Home from "./pages/home/Home";
import { useTranslation } from "react-i18next";
import ChemicalResults from './pages/chemicalResults/ChemicalResults';
import GlovesSelector from './pages/glovesSelector/GloveSelector';
import InfoArea from './pages/infoArea/InfoArea';
import Admin from './pages/admin/Admin';
import { addAnalyticsLaunchScript } from "../common/functions/utils";
import { kclRootState } from "../../store/gloveSelectorStore";

const KclGlovesHome = () => {
    // adding analytics launch 
    addAnalyticsLaunchScript(process.env.REACT_APP_ANALYTICS_LAUNCH_URL);
    const { t } = useTranslation();
    const { PAGE_NAVIGATION } = useSelector((state: kclRootState) => state?.glovesSelector?.config || {});

    return (<>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path={PAGE_NAVIGATION?.CHEMICAL_SEARCH} element={<ChemicalSearch />} />
            <Route path={PAGE_NAVIGATION?.CHEMICAL_RESULTS} element={<ChemicalResults />} />
            <Route path={PAGE_NAVIGATION?.GLOVES_SELECTOR} element={<GlovesSelector />} />
            <Route path={PAGE_NAVIGATION?.INFO_AREA} element={<InfoArea />} />
            <Route path={PAGE_NAVIGATION?.ADMIN_DASHBOARD} element={<Admin />} />
        </Routes></>
    );
};
export default KclGlovesHome;
